import api from "./Api";

class PedidoItemDetPesagemService {
  GetPedidoItemDetPesagem(payload) {
    return api.get("/v1/pedidoItemDetPesagem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoItemDetPesagem(payload) {
    return api.post("/v1/pedidoItemDetPesagem/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoItemDetPesagem(payload) {
    return api.put("/v1/pedidoItemDetPesagem/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoItemDetPesagem(payload) {
    return api
      .delete("/v1/pedidoItemDetPesagem/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoItemDetPesagemOData(payload) {
    return api.get("/OData/PedidoItemDetPesagem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoItemDetPesagemService();
